//
// RendererModel.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./GTLModel";
import "@sas-dvr/ltjs-commons/BaseView";

var RendererModel = createModule("gtl::RendererModel", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        name: 7,
    },
    ,
    ,
    {
        createBaseView: [1],
    },
    ,
    ,
]);
export default RendererModel;
